module.exports = __webpack_public_path__ + "static/media/Bastei,Germany.4ecb828f.png";